<template>
  <div class="econ-overview">
    <CountrySummaryEvents :region="region"></CountrySummaryEvents>
    <CountrySummaryInfo :region="region"></CountrySummaryInfo>
    <CountrySummaryPositions :region="region"></CountrySummaryPositions>
  </div>
</template>

<script setup>
import CountrySummaryEvents from "@/components/CountrySummaryEvents.vue"
import CountrySummaryInfo from "@/components/CountrySummaryInfo.vue"
import CountrySummaryPositions from "@/components/CountrySummaryPositions.vue"

defineProps({ region: { type: String, required: true } })
</script>

<style>
@media print {
  .econ-overview > * {
    page-break-inside: avoid;
    break-inside: avoid;
  }
}
</style>
